import { serializable, alias, object, primitive } from 'serializr';
import { AddressModel } from './address.model';
import { Organization } from './organization.model';

export class LocationModel {
  @serializable
  id?: number;

  @serializable
  name?: string;

  @serializable
  category?: string;

  @serializable(alias('is_completed'))
  isCompleted?: boolean;

  @serializable(alias('share_percentage', primitive()))
  sharePercentage?: string | number;

  @serializable(object(AddressModel))
  address?: AddressModel;

  @serializable(object(Organization))
  organization?: Organization;
}
